import { Component, TextField } from '@contember/admin'
import * as React from 'react'

export const LinkForm = Component(() => {
	return <TextField field="link.url" label="URL" />
}, 'LinkForm')
